import store from '@/store'
import { getVehicleAndPeopleFlow, getToiletFlow, GetAllScenicAreaVehicleAndPeopleFlow} from '../../../api/eastCoastMonitorApi/ElasticApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  vehicleAndPeople: [],
  toiletFlow: [],
  totalVehicleAndPeople: {}
}

const getters = {
  getVehicleAndPeople: state => {
    return state.vehicleAndPeople
  },

  getSingleVehicleAndPeople: state => (scenicAreaId = -1) => {
    let target = state.vehicleAndPeople.find(e => e[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.SCENIC_AREA_ID] === scenicAreaId)
    return Utils.isEmptyObject(target)? {} : target
  },
  
  getToiletFlow: state => {
    return state.toiletFlow
  }
}

const actions = {
  async getVehicleAndPeople({ commit }, condition = {}) {
    const scenicAreaList = store.getters['scenicArea/getAllScenicArea']
    const carFlowScenicAreaList = scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    let searchAreaList = []
    let vehicleAndPeopleDataList = []
    
    if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.scenicAreaId)) {
      searchAreaList = carFlowScenicAreaList
    } else {
      searchAreaList = carFlowScenicAreaList.filter(sc => sc.id === condition.scenicAreaId)
    }

    // console.log('searchAreaList', searchAreaList);

    for(let i = 0 ; i < searchAreaList.length ; i++) {
      const id = searchAreaList[i].id
      const areasSort = searchAreaList[i].areasSort;
      
      const result = await getVehicleAndPeopleFlow({id: id})
      // console.log("result",result);
      if(result.success && !Utils.isEmptyObject(result.data)) {
        result.data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.SCENIC_AREA_ID] = id;
        result.data.areaSort = areasSort;// 新增area sort 的資料進入data ，以便排序
        vehicleAndPeopleDataList.push({result: result.data, id: id}) 
       
      }

    }
    // console.log("vehicleAndPeopleDataList",vehicleAndPeopleDataList);

    commit('vehicleAndPeople', vehicleAndPeopleDataList)
  },

  async getToiletFlow({commit}) {
    const scenicAreaList = store.getters['scenicArea/getAllScenicArea']
    for(let i = 0 ; i < scenicAreaList.length ; i++) {
      const id = scenicAreaList[i].id
      const result = await getToiletFlow({id: id})
      
      if(result.success && !Utils.isEmptyObject(result.data)) {
        const data = {}
        data[CONST.HOME_PAGE_TOILET_FLOW_ITEM.SCENIC_AREA_ID] = id
        data[CONST.HOME_PAGE_TOILET_FLOW_ITEM.TOILETS] = result.data
        commit('toiletFlow', {result: data, id: id})
      }
    }
  },

  async getAllScenicAreaVehicleAndPeopleFlow({ commit }) {
    const result = await GetAllScenicAreaVehicleAndPeopleFlow()
    if(result.success) {
      commit('totalVehicleAndPeople', result.data)
    }
  }
}

const mutations = {
  vehicleAndPeople: (state, dataList) => {

    dataList.forEach(data => {
      let targetIndex = state.vehicleAndPeople.findIndex(e => e[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.SCENIC_AREA_ID] === data.id);

      if (targetIndex === -1) {
        state.vehicleAndPeople.push(data.result);
      } else {
        state.vehicleAndPeople.splice(targetIndex, 1, data.result);
      }

      state.vehicleAndPeople.sort((a, b) => a.areaSort - b.areaSort);
    });

    // 因景區資料會動態增減，所以要檢查 state.vehicleAndPeople 是否有多餘的資料
    if (state.vehicleAndPeople.length > dataList.length) {
      const ids = dataList.map(data => data.id);
      state.vehicleAndPeople = state.vehicleAndPeople.filter(item => ids.includes(item[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.SCENIC_AREA_ID]));
    };
  
  },
  
  toiletFlow: (state, data) => {
      let targetIndex = state.toiletFlow.findIndex(e => e[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.SCENIC_AREA_ID] === data.id)
      if (targetIndex === -1) {
        state.toiletFlow.push(data.result)
      } else {
        // state.toiletFlow[targetIndex] = data.result;
        state.toiletFlow.splice(targetIndex, 1, data.result); 
      }
  },

  totalVehicleAndPeople: (state, data) => {
    if(Utils.isEmptyObject(data)) {
      state.totalVehicleAndPeople = {}
      return
    }

    state.totalVehicleAndPeople = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}